import { Box, IconButton, Tooltip, useTheme } from '@mui/material'
import { REQUEST_COLOR_TOKENS, requestColorStyles } from '../../theme/requestColorTokens'

export default function ColorTokenPicker({ value, onChange }) {
  const theme = useTheme()
  const mode = theme.palette.mode
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, px: 1, py: 0.5 }}>
      <Tooltip title="Стандартный цвет">
        <IconButton size="small" aria-label="Стандартный цвет" onClick={(event) => { event.stopPropagation(); onChange(null) }}>×</IconButton>
      </Tooltip>
      {REQUEST_COLOR_TOKENS.map(({ token, label }) => {
        const colors = requestColorStyles(token, mode)
        return (
          <Tooltip title={label} key={token}>
            <IconButton
              size="small"
              aria-label={label}
              aria-pressed={value === token}
              onClick={(event) => { event.stopPropagation(); onChange(token) }}
              sx={{ p: 0.5, border: value === token ? `2px solid ${colors.border}` : '2px solid transparent' }}
            >
              <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: colors.background, border: `1px solid ${colors.border}` }} />
            </IconButton>
          </Tooltip>
        )
      })}
    </Box>
  )
}

